import { TipoDeTelhado, Orientacao } from './enum';

export class FornecedorEstruturaItem {
  id: number;
  idFornecedor: number;
  idProduto: number;
  produto: string;
  telhado: TipoDeTelhado;
  orientacao: Orientacao;
  formulaQtd: string;
  ativo: boolean;
  qtdSimulacao: number;
  situacao: string;
}
